module.exports = __webpack_public_path__ + "static/media/4.528b62b8.jpg";